// Feb 2026 OPT-1 · Item 1 — QueryClient singleton so `lib/api.js`
// (axios interceptors) and `index.js` (React tree) share one client.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,      // 60s — matches prior CRA/hooks TTL
      gcTime: 5 * 60_000,     // 5min — keep fresh cache after unmount
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
